const faq = [
	{
		title: 'What is MMP WORLD and what are its objectives?',
		content: (
			<div>
				💡
				<strong>MMP WORLD</strong> is an investment and crowdfunding platform launched by
				the <em>BEM Foundation</em>, designed to create secure financial infrastructures and
				offer profitable opportunities globally for blockchain project development.
			</div>
		),
	},
	{
		title: 'How can I invest in the MMP WORLD project?',
		content: (
			<div>
				💡 Register on the <strong>BemChain project</strong> and purchase at least{' '}
				<strong>5,000 BSM Tokens</strong>. Then, select the MMP option in your dashboard and
				submit your email.
			</div>
		),
	},
	{
		title: 'What are the income models in the MMP WORLD project?',
		content: (
			<div>
				💡 Income models include <em>Referral Marketing</em>,{' '}
				<em>Multi-Level Marketing (MLM)</em>, <em>Binary Commissions</em>, and{' '}
				<em>Reward Programs</em>.
			</div>
		),
	},
	{
		title: 'Do I need prior knowledge of cryptocurrencies to participate?',
		content: (
			<div>
				💡 <strong>No</strong> prior knowledge is needed. MMP WORLD provides user support
				and guidance every step of the way.
			</div>
		),
	},
	{
		title: 'How can I receive my monthly investment profits?',
		content: (
			<div>
				⏰ Monthly profits are credited to your account on the{' '}
				<strong>1st day of each Gregorian month at 12:00 PM UTC</strong>. You can then
				proceed with the withdrawal process.
			</div>
		),
	},
	{
		title: 'How long does it take to withdraw profits or investments?',
		content: (
			<div>
				📤 Withdrawals take about <strong>5 business days</strong>: <em>72 hours</em> for
				conversion, plus <em>48 hours</em> for final transfer.
			</div>
		),
	},
	{
		title: 'What security measures are in place to protect investments?',
		content: (
			<div>
				🔒 MMP WORLD follows <strong>strict KYC standards</strong>, uses{' '}
				<strong>protected servers</strong>, and ensures{' '}
				<strong>professional fund management</strong>. Your information remains
				confidential.
			</div>
		),
	},
	{
		title: 'Can I upgrade my investment package later?',
		content: (
			<div>
				⬆️ Yes, users can upgrade anytime by purchasing a{' '}
				<strong>higher-tier package</strong>.
			</div>
		),
	},
	{
		title: 'Which projects are supported by MMP WORLD?',
		content: (
			<div>
				💡 Projects are evaluated by experts for profitability. Details are available on the{' '}
				<em>BEM Foundation</em> website.
			</div>
		),
	},
	{
		title: 'How do I contact the support team?',
		content: (
			<div>
				💡 Use the <strong>Customer Support</strong> option in your MMP WORLD dashboard to
				submit inquiries.
			</div>
		),
	},
	{
		title: 'Which currencies are accepted?',
		content: (
			<div>
				💵 Only <strong>USDT (TRC20)</strong> is accepted for investments.
			</div>
		),
	},
	{
		title: 'Are there any geographical restrictions?',
		content: (
			<div>
				💡
				<strong>No.</strong> MMP WORLD accepts investments from all countries worldwide.
			</div>
		),
	},
	{
		title: 'What are the Investment and Planer packages?',
		content: (
			<div>
				💡
				<div className='fw-bold'>Investment Packages:</div>
				<ul>
					<li>
						<strong>Blue Diamond Card:</strong> $500–$4,990
					</li>
					<li>
						<strong>Red Diamond Card:</strong> $5,000–$49,990
					</li>
					<li>
						<strong>Black Diamond Card:</strong> $50,000–$99,990
					</li>
					<li>
						<strong>Royal Diamond Card:</strong> $100,000–$1,000,000
					</li>
				</ul>
				<div className='fw-bold'>Planer Packages:</div>
				<ul>
					<li>
						<strong>Start Card:</strong> $500–$4,990
					</li>
					<li>
						<strong>Smart Card:</strong> $5,000–$19,990
					</li>
					<li>
						<strong>Growth Card:</strong> $20,000–$49,990
					</li>
					<li>
						<strong>Elite Card:</strong> $50,000–$99,990
					</li>
					<li>
						<strong>Executive Card:</strong> $100,000–$499,990
					</li>
					<li>
						<strong>Premier Card:</strong> $500,000–$999,990
					</li>
					<li>
						<strong>Exclusive Card:</strong> $1,000,000–$10,000,000
					</li>
				</ul>
			</div>
		),
	},
	{
		title: 'What is the monthly profit percentage?',
		content: (
			<div>
				💡
				<div className='fw-bold'>Investment Packages:</div>
				<ul>
					<li>
						Blue Diamond Card: <strong>6%</strong>
					</li>
					<li>
						Red Diamond Card: <strong>8%</strong>
					</li>
					<li>
						Black Diamond Card: <strong>10%</strong>
					</li>
					<li>
						Royal Diamond Card: <strong>12%</strong>
					</li>
				</ul>
				<div className='fw-bold'>Planer Packages:</div>
				<ul>
					<li>
						Start Card: <strong>6%</strong>
					</li>
					<li>
						Smart Card: <strong>8%</strong>
					</li>
					<li>
						Growth Card: <strong>8%</strong>
					</li>
					<li>
						Elite Card: <strong>10%</strong>
					</li>
					<li>
						Executive Card: <strong>12%</strong>
					</li>
					<li>
						Premier Card: <strong>14%</strong>
					</li>
					<li>
						Exclusive Card: <strong>16%</strong>
					</li>
				</ul>
			</div>
		),
	},
	{
		title: 'Can I terminate my contract early?',
		content: (
			<div>
				⚠️ Yes. Early termination is allowed with the following conditions:
				<ul>
					<li>
						<strong>0–183 days:</strong> 50% penalty + 75% commission refund
					</li>
					<li>
						<strong>183–365 days:</strong> 35% penalty + 75% commission refund
					</li>
					<li>
						<strong>365–730 days:</strong> No penalty, 50% commission refund
					</li>
					<li>
						<strong>After 730 days:</strong> No penalty, no commission refund
					</li>
				</ul>
				<em>Only investors may terminate their contracts.</em>
			</div>
		),
	},
	{
		title: 'How long are the contracts valid?',
		content: (
			<div>
				📜 Minimum duration is <strong>1 year</strong>. Maximum duration depends on reaching
				the package’s Maximum Cap:
				<div className='fw-bold'>Investment Packages:</div>
				<ul>
					<li>
						Blue Diamond Card: <strong>300%</strong>
					</li>
					<li>
						Red Diamond Card: <strong>400%</strong>
					</li>
					<li>
						Black Diamond Card: <strong>400%</strong>
					</li>
					<li>
						Royal Diamond Card: <strong>500%</strong>
					</li>
				</ul>
				<div className='fw-bold'>Planer Packages:</div>
				<ul>
					<li>
						Start Card: <strong>350%</strong>
					</li>
					<li>
						Smart Card: <strong>400%</strong>
					</li>
					<li>
						Growth Card: <strong>450%</strong>
					</li>
					<li>
						Elite Card: <strong>500%</strong>
					</li>
					<li>
						Executive Card: <strong>600%</strong>
					</li>
					<li>
						Premier Card: <strong>800%</strong>
					</li>
					<li>
						Exclusive Card: <strong>1000%</strong>
					</li>
				</ul>
			</div>
		),
	},
	{
		title: 'Until when will MMP WORLD accept investments?',
		content: (
			<div>
				🚀 Until it raises <strong>$25 billion</strong> to fund{' '}
				<strong>10 BEM Foundation projects</strong>.
			</div>
		),
	},
	{
		title: 'Where is MMP WORLD headquartered?',
		content: (
			<div>
				📍 <strong>Yerevan, Armenia</strong> (main office) and{' '}
				<strong>Istanbul, Turkey</strong> (support office).
			</div>
		),
	},
	{
		title: 'Why is authentication (KYC) required?',
		content: (
			<div>
				🛡️ To ensure transparency, prevent money laundering, and maintain platform security.
			</div>
		),
	},
	{
		title: 'Will my investment info be shared with third parties?',
		content: (
			<div>
				⚠️ <strong>No.</strong> Your data is confidential and stored securely{' '}
				<em>offline</em>.
			</div>
		),
	},
	{
		title: 'Are crypto profits taxed?',
		content: (
			<div>
				📉 <strong>No.</strong> There are currently no tax regulations on crypto profits in
				the approved investment countries.
			</div>
		),
	},
];

export default faq;
